import { map } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';
import type {
  MarketTemplateComponent,
  SingleMarketTemplateProps
} from '@swf/sports/types/templates';

import SelectionTable from '../../components/SelectionTable/SelectionTable';

export const Row: MarketTemplateComponent<SingleMarketTemplateProps> = ({ marketId }) => {
  const { widgetSelect } = useEventMarketTemplatesWidget();
  const market = useSelector((state: RootState) => widgetSelect.market(state, marketId));
  const { eventStartTime } = useSelector((state: RootState) =>
    widgetSelect.event(state, market?.eventId ?? -1)
  );

  if (!market) return null;

  const headers = map(market.runners, 'runnerName');

  return (
    <SelectionTable
      header={headers}
      rows={[market.runners]}
      market={market}
      testId="market-template-row"
      eventStartTime={eventStartTime}
    />
  );
};

Row.marketTemplateType = 'EVENT';

export default Row;
